var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"mt-12 mb-12"},[_c('div',{attrs:{"id":"companyInfo"}},[_c('Markdown',{attrs:{"markdown":_vm.company_info}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }